
import { Component, Emit, InjectReactive, Prop, Vue } from 'vue-property-decorator';

import OrderProgress from '@/components/OrderProgress.vue';
import { OrderSteps } from '@/enums';
import BasketModule from '@/store/modules/basket';

@Component({
  components: {
    OrderProgress,
  }
})
export default class OrderHeader extends Vue {
  @InjectReactive() isMobile!: boolean;
  @Prop({ default: false }) reviewDrawerOpen: boolean;

  @Emit('toggle-review-drawer')
  toggleReviewDrawer(ev) {
    return ev;
  }

  get orderSteps() {
    return Object.values(OrderSteps || {});
  }

  get stepInfo(): OrderStep {
    const routeName = this.$route?.name;
    return (this.orderSteps?.find(({ view, aliasViews = [] }) => {
      return view === routeName || aliasViews?.includes(routeName as string);
    })) || {} as OrderStep;
  }

  get hideCartIfEmpty() {
    return this.stepInfo.hideCartIfEmpty && BasketModule.hasProducts;
  }
}
